import { isFreePackage, isIndividualPackage, isNonFreePackage, isPaidPackage } from '@/utils/packagePolicy'

export const MAX_OBJECT_IMAGES = 15
export const MAX_OBJECT_NAME_LENGTH = 69
export const FREE_PACKAGE_PUBLISHED_IMAGE_LIMIT = 2

export const FREE_PACKAGE_IMAGE_HINT =
  'Im free-Paket können nur 2 Bilder ausgegeben werden. Weitere Bilder bleiben zwar im Objekt gespeichert, werden aber nicht auf den Portalen ausgeliefert.'

export const PREMIUM_EXTERNAL_LINKS_HINT =
  'Dies ist ein Premium-Feature. Sie können die Daten abspeichern aber ohne Premium-Paket werden sie nicht auf den Portalen ausgeliefert.'

export const PREMIUM_EXTERNAL_LINKS_CTA = 'Jetzt Pakete ansehen.'

export const PREMIUM_EXTERNAL_ICAL_HINT =
  'Dies ist ein Premium-Feature. Sie können die Daten abspeichern, aber ohne Premium-Paket wird der externe Kalender nicht auf den Portalen ausgeliefert.'

export const PREMIUM_PHONE_HINT =
  'Dies ist ein Premium-Feature. Sie können die Einstellung abspeichern, aber ohne kostenpflichtiges oder individuelles Paket wird die Telefonnummer nicht auf den Portalen ausgeliefert.'

export const hasFreePackageForBaseType = (activePackages = [], baseType) => {
  const normalizedBaseType = String(baseType || '').toLowerCase()
  return activePackages.some((pkg) => (
    String(pkg?.base_type ?? pkg?.package?.base_type ?? '').toLowerCase() === normalizedBaseType
    && isFreePackage(pkg)
  ))
}

export const hasNonFreePackageForBaseType = (activePackages = [], baseType) => {
  const normalizedBaseType = String(baseType || '').toLowerCase()
  return activePackages.some((pkg) => (
    String(pkg?.base_type ?? pkg?.package?.base_type ?? '').toLowerCase() === normalizedBaseType
    && isNonFreePackage(pkg)
  ))
}

export const hasPaidOrIndividualPackageForBaseType = (activePackages = [], baseType) => {
  const normalizedBaseType = String(baseType || '').toLowerCase()
  return activePackages.some((pkg) => (
    String(pkg?.base_type ?? pkg?.package?.base_type ?? '').toLowerCase() === normalizedBaseType
    && (isPaidPackage(pkg) || isIndividualPackage(pkg))
  ))
}
